import { useState, useEffect } from "react";

function useLocalStorage(key, initialValue) {
  // Initialisierung: versuche aus localStorage zu lesen, sonst initialValue
  const [value, setValue] = useState(() => {
    if (typeof window === "undefined") return initialValue;
    try {
      const stored = localStorage.getItem(key);
      return stored ? JSON.parse(stored) : initialValue;
    } catch {
      return initialValue;
    }
  });

  // Bei jeder Änderung schreiben wir zurück
  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Silently fail
    }
  }, [key, value]);

  return [value, setValue];
}

export default useLocalStorage;
